import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowTypography } from './GlowTypography';
import { GlowTypographyProps } from './GlowTypographyProps';

export const GlowTextCaption: ComponentMemo<GlowTypographyProps> = memo(({ ...props }) => {
    return <GlowTypography fontSize={'caption'} {...props} />;
});

GlowTextCaption.displayName = 'GlowTextCaption';
